import { Patient } from '../../store/types/patient';

import Hotkeys from 'react-hot-keys';
import { motion } from 'framer-motion';
import { getAclViewClassName } from '../../restrictions/utils';
import { SREV2 } from '../../api/pushGenie';

const GoToPadConfirmation: React.FC<{
    onCancel: () => void;
    onGotoAppt: () => void;
    onGotoPad: () => Promise<void>;
    patient: Patient;
}> = ({ onCancel, onGotoAppt, onGotoPad, patient }) => {
    return (
        <Hotkeys keyName="esc">
            <motion.div
                initial={{ opacity: 0 }}
                exit={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                style={{ zIndex: 9999 }}
                transition={{ duration: 0.2, ease: 'linear' }}
                className="font-lato select-none"
            >
                <div
                    className="absolute inset-0 bg-darwin-neutral-1000 bg-opacity-50 z-50"
                    onClick={onCancel}
                ></div>
                <div
                    className="modal-content w-450"
                    style={{
                        position: 'absolute',
                        background: 'transparent',
                    }}
                >
                    <span
                        className="absolute top-16 right-16 p-4 cursor-pointer"
                        onClick={onCancel}
                    >
                        <svg
                            width="10"
                            height="9"
                            viewBox="0 0 10 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8.88477 1.60352L5.83789 4.65039L8.85938 7.67188C9.11328 7.90039 9.11328 8.28125 8.85938 8.50977C8.63086 8.76367 8.25 8.76367 8.02148 8.50977L4.97461 5.48828L1.95312 8.50977C1.72461 8.76367 1.34375 8.76367 1.11523 8.50977C0.861328 8.28125 0.861328 7.90039 1.11523 7.64648L4.13672 4.625L1.11523 1.60352C0.861328 1.375 0.861328 0.994141 1.11523 0.740234C1.34375 0.511719 1.72461 0.511719 1.97852 0.740234L5 3.78711L8.02148 0.765625C8.25 0.511719 8.63086 0.511719 8.88477 0.765625C9.11328 0.994141 9.11328 1.375 8.88477 1.60352Z"
                                fill="#1A1A1A"
                            />
                        </svg>
                    </span>
                    <div className="px-24 py-36 bg-white flex flex-col rounded-12 items-center space-y-12">
                        <span>
                            <svg
                                width="27"
                                height="24"
                                viewBox="0 0 27 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M13.5 24C9.1875 24 5.25 21.75 3.09375 18C0.9375 14.2969 0.9375 9.75 3.09375 6C5.25 2.29688 9.1875 0 13.5 0C17.7656 0 21.7031 2.29688 23.8594 6C26.0156 9.75 26.0156 14.2969 23.8594 18C21.7031 21.75 17.7656 24 13.5 24ZM18.7969 9.79688H18.75C19.2188 9.375 19.2188 8.67188 18.75 8.20312C18.3281 7.78125 17.625 7.78125 17.2031 8.20312L12 13.4531L9.79688 11.25C9.32812 10.7812 8.625 10.7812 8.20312 11.25C7.73438 11.6719 7.73438 12.375 8.20312 12.7969L11.2031 15.7969C11.625 16.2656 12.3281 16.2656 12.7969 15.7969L18.7969 9.79688Z"
                                    fill="#19A66A"
                                />
                            </svg>
                        </span>
                        <div className="flex space-x-16">
                            <span className="font-700 text-18 text-center">
                                Vitals copied to Pad successfully!
                            </span>
                        </div>
                        <span className="text-14 px-16 text-darwin-neutral-800 text-center">
                            Do you want to start writing Rx for{' '}
                            <span className="font-700">{patient.personal.name.f}</span>?
                        </span>

                        <div className="flex items-center gap-16 pt-8">
                            <div
                                onClick={onGotoAppt}
                                className="flex rounded-8 px-12 py-6 cursor-pointer bg-white border border-darwin-accent-bright-blue-800 text-darwin-accent-bright-blue-800"
                            >
                                Go to queue
                            </div>
                            <button
                                onClick={onGotoPad}
                                className="flex rounded-8 px-12 py-6 cursor-pointer bg-darwin-accent-bright-blue-800 text-white"
                            >
                                Start writing Rx
                            </button>
                        </div>
                    </div>
                </div>
            </motion.div>
        </Hotkeys>
    );
};

export default GoToPadConfirmation;
